import React, { useState, useEffect, useRef } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import { SetupWorker } from 'msw/browser';

import { useLocalStorage, paths } from 'shared/base';

import { isMSWEnabledEnvironment } from './constants';
import { customHandlers } from './customHandlers';

export function MSWProvider({ children }: { children: React.ReactNode | undefined }) {
  const [loaded, setLoaded] = useState(false);
  const { setValue: setUtilizeMocks, value: utilizeMocks } = useLocalStorage(
    `platform-utilize-mocks`,
    false,
  );
  const workerRef = useRef<SetupWorker | null>(null);

  useEffect(() => {
    if (utilizeMocks && isMSWEnabledEnvironment) {
      if (typeof window !== 'undefined') {
        import('msw/browser').then(({ setupWorker }) => {
          workerRef.current = setupWorker(...(customHandlers as any));
          workerRef.current.start().then(() => {
            setLoaded(true);
          });
        });
      }
    } else {
      setLoaded(true);
    }

    return () => {
      if (workerRef.current) {
        workerRef.current.resetHandlers();
        workerRef.current.stop();
      }
    };
  }, [utilizeMocks]);

  const toggleMocks = async () => {
    setUtilizeMocks(!utilizeMocks);

    if (utilizeMocks) {
      if (workerRef.current) {
        workerRef.current.resetHandlers();
        workerRef.current.stop();
      }
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (const registration of registrations) {
          await registration.unregister();
        }
      }
    }

    window.location.replace(paths.platform.index);
  };

  return (
    <Box height="100%" position="relative">
      {loaded && (
        <>
          {children}
          {isMSWEnabledEnvironment && (
            <Button
              color={utilizeMocks ? 'warning' : 'info'}
              onClick={toggleMocks}
              size="small"
              sx={{ bottom: 5, left: 5, position: 'fixed', zIndex: 1000 }}
            >
              {utilizeMocks ? 'Disable Mocks' : 'Enable Mocks'}
            </Button>
          )}
        </>
      )}
    </Box>
  );
}
